export enum ProfileDomain {
  Account = 'account',
  Subscriptions = 'subscriptions',
  Favorites = 'favorites',
  History = 'history',
  Sessions = 'sessions',
  Payments = 'payments',
}
